// extracted by mini-css-extract-plugin
export var divider = "_nc-0";
export var systemMessage = "_nc-1";
export var systemMessageWrapper = "_nc-2";